import { type ReactNode } from 'react';
import { clsx } from 'clsx';
import { RefreshCw } from 'lucide-react';

export function EmptyState({
  icon,
  title,
  body,
  action,
  className,
}: {
  icon?: ReactNode;
  title: string;
  body?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center px-6 py-14 text-center',
        className,
      )}
    >
      {icon && (
        <div className="glass mb-4 grid size-16 place-items-center rounded-none border border-hairline text-muted">
          {icon}
        </div>
      )}
      <h3 className="display text-[17px] font-bold text-ink">{title}</h3>
      {body && <p className="mt-1.5 max-w-[26ch] text-[14px] leading-relaxed text-muted">{body}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Skeleton({ className }: { className?: string }) {
  return <div className={clsx('skeleton rounded-none', className)} />;
}

export function LoadingBlock({ rows = 4 }: { rows?: number }) {
  return (
    <div className="card space-y-4 p-5">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3">
          <Skeleton className="size-10 shrink-0 rounded-none" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-3.5 w-3/5 rounded-none" />
            <Skeleton className="h-3 w-2/5 rounded-none" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ErrorBlock({ error, onRetry }: { error: Error | null; onRetry?: () => void }) {
  return (
    <div className="card p-6 text-center">
      <p className="text-[14px] text-danger">Gagal memuat data.</p>
      <p className="mt-1 text-[12px] text-muted">
        {error?.message ?? 'Terjadi kesalahan jaringan.'}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 inline-flex items-center gap-2 rounded-none bg-surface-2 px-4 py-2 text-[13px] font-semibold press"
        >
          <RefreshCw className="size-3.5" /> Coba lagi
        </button>
      )}
    </div>
  );
}
